import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UnsubscribeComponent } from "../../../../generals/Components";
import { AdminModuleDetail, ModuleMailNotifierConfig } from "../../../../interfaces/interfaces";
import { ApiService } from "../../../../services/api.service";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: 'app-mailnotifiermodule',
    templateUrl: './mailnotifiermodule.component.html',
    styleUrls: ['./mailnotifiermodule.component.scss']
})
export class MailNotifierModuleComponent extends UnsubscribeComponent implements OnInit {

    @Input() module: AdminModuleDetail<ModuleMailNotifierConfig> = null;
    onErrorEmails: string[] = [];
    onSuccessEmails: string[] = [];

    @Output() inited: EventEmitter<boolean> = new EventEmitter();
    @Output() configChanged: EventEmitter<boolean> = new EventEmitter();

    constructor(
        private apiService: ApiService
    ) {
        super();
    }

    ngOnInit(): void {
        this.inited.emit(true);
        this.onErrorEmails = this.module.config.onErrorEmails || [];
        this.onSuccessEmails = this.module.config.onSuccessEmails || [];
    }

    configChangedEvent(): void {
        this.configChanged.emit(true);
    }

    saveConfig(): void {
        const config: ModuleMailNotifierConfig = {
            onErrorEmails: this.onErrorEmails,
            onSuccessEmails: this.onSuccessEmails
        };
        this.apiService.saveModuleConfig(this.module.id, config).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
            this.configChanged.emit(false);
        });
    }
}